import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ApiQueryParam, ApiService} from "../service/ApiService";
import {RootState} from "./store";
import {partnerResultCollectionType, partnerResultType} from "../types/Api/PartnerResultType";
import {partnerHydrator} from "../models/hydrator/partnerHydrator";
import {partner} from "../models/partner";

export const fetchData = createAsyncThunk('get-partner', async(_, thunkAPI): Promise<any> => {
  const state: state = (thunkAPI.getState() as RootState).partner;

  if (state.init > 0) {
    return undefined;
  }

  const apiFilters: ApiQueryParam = new ApiQueryParam();

  apiFilters.addFilter({
    field: 'enabled',
    value: '1'
  });

  apiFilters.addSort({
    by: 'label',
    direction: 'ASC'
  });

  const result: partnerResultCollectionType =  await ApiService.get('/partner', apiFilters) as partnerResultCollectionType;

  return {
    paginate: {
      page: result._page,
      pageCount: result._page_count,
      total: result._total_items
    },
    data: result._embedded.partners.map((partner: partnerResultType) => {
      return partnerHydrator.hydrate(partner);
    })
  };
})

interface state {
  init: number;
  loading: boolean;
  paginate?: {
    page: number;
    pageCount: number;
    total: number;
  }
  data: partner[]
}

const initialState: state = {
  init: 0,
  loading: false,
  paginate: undefined,
  data: []
}

export const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {},
  extraReducers: (builder): void => {
    builder.addCase(fetchData.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(fetchData.fulfilled, (state, action) => {
      if (action.payload !== undefined) {
        state.paginate = action.payload.paginate;
        state.data = action.payload.data;
        state.init = Date.now();
      }

      state.loading = false;
    })
    builder.addCase(fetchData.rejected, (state) => {
      state.loading = false;
    })
  }
});

export default partnerSlice.reducer;